module.exports = __webpack_public_path__ + "static/img/8.1b49b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/8.jpg
// module id = Jxah
// module chunks = 1